import styled from 'styled-components'
export const NewsLetterWrapper = styled.section`
color:white;
width:100%;
justify-content:center;
align-items:center;
display:flex;
height:500px;
`;

export const NewsLetterDiv = styled.div`
`

export const NewsLetterTitle = styled.h1`
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 56px;
line-height: 84px;
text-align: center;
margin-bottom:20px;

margin-top:70px;

font-size: 72px;
background: linear-gradient(90deg, #00DBDE 0%, #FC00FF 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;


`

export const NewsLetterButton = styled.h2`
font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 32px;
line-height: 38px;

text-align: center;
margin-top:0px;
color: #FFFFFF;
margin-left:120px;

text-align:center;
display:flex;
align-items:center;
padding-bottom:4px;
background:
  linear-gradient(
    to left, 
    #AC32E4 0%,
    #7918F2 50%,
    #4801FF 100%
  )
  left 
  bottom
  #121212   
  no-repeat; 
background-size:100% 3px;
display: inline-block;
position:relative;
background-image: url('../../assets/images/backgroundelipses.png');
background-repeat: 'space';
`
export const ImageClickElement = styled.img`
position:absolute;
`